<template>
  <div>
    <el-card>
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="" class="numberSearch">
              <template slot="label">
                <el-select v-model="type1" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                  <!-- 发票秘钥 -->
                  <el-option :label="$t('mdfeTranslate.MDFEKey')" value="keys" />
                  <!-- 车签号 -->
                  <el-option :label="$t('collectionCenter.carNumber')" value="tags" />
                </el-select>
              </template>
              <InputTextareaCmp
                ref="inputTextareaRef"
                :val="listVal"
                :max-length="2000"
                :min-rows="4"
                @input="(_, val) => listVal = val"
              />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-row :gutter="10">
              <el-col :span="10">
                <!-- 操作时间 -->
                <el-form-item :label="$t('GlobalSetObj.operationTime')">
                  <el-date-picker
                    v-model="invoiceIssueTime"
                    type="datetimerange"
                    range-separator="-"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :start-placeholder="$t('GlobalSetObj.startDate')"
                    :end-placeholder="$t('GlobalSetObj.endDate')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <!--所属网点-->
                <el-form-item :label="$t('collectionCenter.belongD')">
                  <el-select
                    v-model="queryForm.params.siteIds"
                    :placeholder="$t('collectionCenter.pleaseChoose')"
                    clearable
                    filterable
                    remote
                    multiple
                    reserve-keyword
                    :remote-method="getSiteOption"
                    style="width: 100%;"
                    @visible-change="getSiteOptionVisible"
                  >
                    <el-option
                      v-for="item in siteAllList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <!--操作类型-->
                <el-form-item :label="$t('collectionCenter.operationType')">
                  <el-select
                    v-model="queryForm.params.operationType"
                    clearable
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    style="width: 100%;"
                  >
                    <!-- 系统自动 -->
                    <el-option :label="$t('mdfeTranslate.SystemAutomatic')" :value="1" />
                    <!-- 用户手动 -->
                    <el-option :label="$t('mdfeTranslate.UserManual')" :value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div>
                  <!--查询-->
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    @click="search"
                  >{{ $t('basicData.Search') }}
                  </el-button>
                  <!--重置-->
                  <el-button
                    icon="el-icon-refresh"
                    size="mini"
                    @click="onReset"
                  >{{ $t('basicData.reset') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <!--导出-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:excludeRepeatedLoadingData_export'"
          type="primary"
          size="small"
          @click="exportData"
        >{{ $t('collectionCenter.export') }}
        </el-button>
        <!--数据剔除-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:excludeRepeatedLoadingData_dataExclusion'"
          type="primary"
          size="small"
          @click="openDataExclusion"
        >{{ $t('mdfeTranslate.DataExclusion') }}
        </el-button>
        <!--        <el-button-->
        <!--          v-permit:remove="'btn:invoiceCenter:excludeRepeatedLoadingData_validateRepeat'"-->
        <!--          type="primary"-->
        <!--          size="small"-->
        <!--          @click="openRepeatRate"-->
        <!--        >{{ $t('mdfeTranslate.RepeatRateConfiguration') }}-->
        <!--        </el-button>-->
      </div>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.minWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'vtag'">
              <div v-for="(item, ind) in scope.row.vtag" :key="ind">
                {{ item }}
              </div>
            </div>
            <div v-else-if="item.prop === 'bag'">
              <div v-for="(item, ind) in scope.row.bag" :key="ind">
                {{ item }}
              </div>
            </div>
            <div v-else-if="item.prop === 'mdfeKey'">
              <div v-for="(item, ind) in scope.row.mdfeKey" :key="ind">
                {{ item }}
              </div>
            </div>
            <div v-else-if="item.prop === 'updateUser'">
              <div>{{ createUser[scope.row.updateUser] }}</div>
            </div>
            <div v-else-if="item.prop === 'operationType'">
              <div>
                {{ scope.row.operationType === 1 ? $t('mdfeTranslate.SystemAutomatic') : $t('mdfeTranslate.UserManual') }}
              </div>
            </div>
            <div v-else>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <data-exclusion ref="dataExclusionRef" :key="dataExclusionKey" @updateTableData="updateTableData" />
    <el-dialog
      :title="$t('mdfeTranslate.RepeatRateConfiguration')"
      :visible.sync="showRepeatRateWindow"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="margin-bottom: 30px;">
        <el-form
          ref="repetitionRateRef"
          :model="repetitionRate"
          label-position="top"
          size="small"
          style="display: inline-block;margin-left: 10px;"
        >
          <el-form-item
            :label="$t('mdfeTranslate.RepeatRateConfiguration')"
            prop="repeatRate"
            :rules="{ required: true, validator: validateRepeatRate, trigger: ['blur','change'] }"
          >
            <el-input v-model="repetitionRate.repeatRate" style="width: 260px;" /> %
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="closeRepeatRate"
        >{{ $t('collectionCenter.cancel') }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="confirmRepeatRate"
        >{{ $t('collectionCenter.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { query10Site } from '@/api/bulkyExpress';
import dataExclusion from './dataExclusion.vue';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import dayjs from 'dayjs';
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import { exportRepeatPackage, getRepeatPackagePage, getRepeatRate, updateRepeatRate } from '@/api/invoiceCenter';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { goResourceTaskList } from '@/utils/goExportList';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'ExcludeRepeatedLoadingData',
  components: {
    InputTextareaCmp,
    dataExclusion
  },
  mixins: [estimateTableHeight],
  data() {
    const validateRepeatRate = (rule, value, callback) => {
      const pattern = /^(?:0|[1-9]|[1-9][0-9]|100)$/;
      if (!value) {
        callback(new Error(this.$t('collectionCenter.notNull')));
      } else if (!pattern.test(value)) {
        callback(new Error(this.$t('mdfeTranslate.OnlyNumbersBetween0And100Entered')));
      } else {
        callback();
      }
    };
    return {
      invoiceIssueTime: [startTime, endTime],
      type1: 'keys',
      listVal: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          operationType: null,
          startTime: startTime,
          endTime: endTime,
          siteIds: [],
          keys: [],
          tags: []
        }
      },
      repetitionRate: {
        repeatRate: ''
      },
      siteAllList: [],
      pickerMinDate: '',
      pickerRange: 30 * 24 * 60 * 60 * 1000, // 可选择日期范围 为30天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      tableData: [],
      selectedData: [],
      total: 0,
      tableHeaderList: [
        // 批次号
        { label: this.$t('mdfeTranslate.BatchNumber'), prop: 'traceNumber', minWidth: 160 },
        // '车签号'
        { label: this.$t('collectionCenter.carNumber'), prop: 'vtag', minWidth: 160 },
        // 'mdfe秘钥'
        { label: this.$t('mdfeTranslate.MDFEKey'), prop: 'mdfeKey', minWidth: 360 },
        // 操作类型
        { label: this.$t('collectionCenter.operationType'), prop: 'operationType', minWidth: 160 },
        // '操作时间'
        { label: this.$t('GlobalSetObj.operationTime'), prop: 'updateTime', minWidth: 160 },
        // '操作人账号'
        { label: this.$t('mdfeTranslate.OperatorAccount'), prop: 'code', minWidth: 160 },
        // '操作人'
        { label: this.$t('operationCenter.operator'), prop: 'updateUser', minWidth: 160 },
        // 所属网点
        { label: this.$t('collectionCenter.belongD'), prop: 'siteName', minWidth: 180 },
        // 总订单数量
        { label: this.$t('mdfeTranslate.TotalOrderQuantity'), prop: 'totalOrderCount', minWidth: 180 },
        // 重复单号数量
        { label: this.$t('mdfeTranslate.RepeatOrderNumberQuantity'), prop: 'repeatOrderCount', minWidth: 180 },
        // 重复明细
        { label: this.$t('mdfeTranslate.RepeatDetails'), prop: 'bag', minWidth: 180 },
        // 重复率
        { label: this.$t('mdfeTranslate.RepeatRate'), prop: 'repeatRate', minWidth: 180 }
      ],
      createUser: [],
      dataExclusionKey: new Date().getTime(),
      validateRepeatRate,
      isDisabled: true,
      showRepeatRateWindow: false
    };
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.isDisabled = !this.$store.getters.button_permissions.includes(
      'btn:invoiceCenter:excludeRepeatedLoadingData_validateRepeat'
    );
    this.getSiteOption();
    this.$nextTick(() => {
      this.search();
    });
  },
  methods: {
    // 打开重置弹窗
    openRepeatRate() {
      this.getRepeatRateData();
      this.showRepeatRateWindow = true;
    },
    // 关闭重置弹窗
    closeRepeatRate() {
      this.repetitionRate.repeatRate = '';
      setTimeout(() => {
        this.$refs['repetitionRateRef'].clearValidate();
        this.showRepeatRateWindow = false;
      }, 0);
    },
    // 确认修改重复率
    confirmRepeatRate() {
      this.$confirm(this.$t('mdfeTranslate.modifyTheRepeatRate'), this.$t('GlobalSetObj.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning',
        callback: (action) => {
          if (action === 'confirm') {
            this.$refs.repetitionRateRef.validate(valid => {
              if (valid) {
                this.changeRepeatRate();
                this.closeRepeatRate();
              }
            });
          }
        }
      });
    },
    // 更新数据
    updateTableData() {
      this.getTable();
    },
    // 修改重复率
    changeRepeatRate() {
      const param = {
        repeatRate: this.repetitionRate.repeatRate
      };
      updateRepeatRate(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
        }
      });
    },
    // 查询重复率
    getRepeatRateData() {
      getRepeatRate().then(res => {
        if (res.code === 200) {
          this.repetitionRate.repeatRate = res.data.repeatRate;
        }
      });
    },
    // 数据勾选
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    // 导出
    exportData() {
      const paramData = this.queryFormData();
      const queryParam = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: paramData
      };
      const ids = [];
      this.selectedData.map(item => {
        ids.push(item.id);
      });
      queryParam.params.ids = ids;
      exportRepeatPackage(queryParam).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 打开数据剔除弹窗
    openDataExclusion() {
      this.$refs.dataExclusionRef.openDataExclusion();
    },
    // 网点选项弹出打开时查询网点
    getSiteOptionVisible(val) {
      if (val) {
        this.getSiteOption();
      }
    },
    // 获取所有网点
    getSiteOption(name = '') {
      query10Site(name).then(res => {
        if (res.code === 200) {
          this.siteAllList = res.data;
        }
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTable();
    },
    // 重置
    onReset() {
      this.queryForm.pageNumber = 1;
      this.invoiceIssueTime = [startTime, endTime];
      this.queryForm.params = {
        operationType: null,
        startTime: startTime,
        endTime: endTime,
        siteIds: [],
        keys: [],
        tags: []
      };
      this.listVal = '';
      this.getTable();
    },
    // 查询条件整理
    queryFormData() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      const paramData = {
        operationType: this.queryForm.params.operationType,
        siteIds: this.queryForm.params.siteIds,
        keys: [],
        tags: [],
        startTime: '',
        endTime: ''
      };
      if (inputVal.length > 0) {
        paramData[this.type1] = inputVal;
      }
      if (Array.isArray(this.invoiceIssueTime) && this.invoiceIssueTime.length === 2) {
        paramData.startTime = this.invoiceIssueTime[0];
        paramData.endTime = this.invoiceIssueTime[1];
      } else {
        paramData.startTime = null;
        paramData.endTime = null;
      }
      return paramData;
    },
    // 获取表格数据
    getTable() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      const paramData = this.queryFormData();
      const queryParam = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: paramData
      };
      if (!inputVal || inputVal.length === 0) {
        if (!queryParam.params.startTime || !queryParam.params.endTime) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      } else {
        if (inputVal.length > 2000) {
          this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
          return;
        }
      }
      getRepeatPackagePage(queryParam).then(res => {
        if (res.code === 200) {
          const { records, total } = res.data;
          records.map(item => {
            item.bag = item.bag ? item.bag.split(',') : [];
            item.mdfeKey = item.mdfeKey ? item.mdfeKey.split(',') : [];
            item.vtag = item.vtag ? item.vtag.split(',') : [];
          });
          this.tableData = records;
          this.total = total;
        }
      });
      console.log(queryParam, '===this.queryForm');
    },
    // 每页显示数量改变时触发
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    },
    // 当前页码改变时触发
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    }
  }
};
</script>
<style>
.numberSearch .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
</style>
